export default "__VITE_ASSET__BPR7$2i0__"